import React, { useState, useEffect, useRef } from 'react';

// Відстежуємо ширину вікна, щоб адаптувати розкладку під телефон / планшет / широкий екран
function useViewport() {
  const [w, setW] = useState(window.innerWidth);
  useEffect(() => {
    const fn = () => setW(window.innerWidth);
    window.addEventListener('resize', fn);
    return () => window.removeEventListener('resize', fn);
  }, []);
  return w;
}

const INFO = [
  { icon: '📍', label: 'Адреса', value: 'Урочище Околиця, 1, Якушинці', sub: 'Вінницька область, 23222' },
  { icon: '📞', label: 'Телефон', value: '+38 (096) 736-51-96', sub: 'Щодня з 11:00 до 23:00', link: 'tel:+380967365196' },
  { icon: '🕐', label: 'Години роботи', value: 'Пн-Нд: 11:00 - 23:00', sub: 'Кухня: 10:30 - 21:00' },
  { icon: '📶', label: 'Wi-Fi', value: 'LENTOCHKA', sub: 'Пароль: 11111111' },
];

// --- ЕЛЕГАНТНІ ВЕКТОРНІ ІКОНКИ ЗАМІСТЬ ЕМОДЗІ ---
const MenuIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2"></path>
    <path d="M7 2v20"></path>
    <path d="M21 15V2v0a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7"></path>
  </svg>
);

const BarIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M8 22h8"></path>
    <path d="M12 15v7"></path>
    <path d="M12 15a7.5 7.5 0 0 0 7.5-7.5V2H4.5v5.5A7.5 7.5 0 0 0 12 15z"></path>
    <path d="M4.5 5.5h15"></path>
  </svg>
);

const KidsIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="m7 11 5 11 5-11"></path>
    <path d="M17 11a5 5 0 0 0-10 0"></path>
  </svg>
);

const FEATURES = [
    { icon: <MenuIcon />, title: 'Меню', desc: 'Страви від шеф-кухаря', tab: 'menu' },
    { icon: <BarIcon />, title: 'Бар', desc: 'Понад 80 позицій напоїв', tab: 'bar' },
    { icon: <KidsIcon />, title: 'Дитяче меню', desc: 'Спеціально для малечі', tab: 'menu', categoryId: 4 },
];

const SOCIALS = [
    {
        name: 'Instagram',
        icon: (
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                <rect x="2" y="2" width="20" height="20" rx="5" stroke="currentColor" strokeWidth="1.8" />
                <circle cx="12" cy="12" r="4.5" stroke="currentColor" strokeWidth="1.8" />
                <circle cx="17.5" cy="6.5" r="1" fill="currentColor" />
            </svg>
        ),
        url: 'https://www.instagram.com/okolitsya_lentochka?igsh=c25ocTJrNG93dndu',
        color: '#E1306C',
    },
    {
        name: 'Facebook',
        icon: (
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
            </svg>
        ),
        url: 'https://www.facebook.com/okolica.akusinci/',
        color: '#1877F2',
    },
    {
        name: 'TikTok',
        icon: (
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                <path d="M9 12a4 4 0 104 4V4a5 5 0 005 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        ),
        url: 'https://www.tiktok.com/@okolitsya_lento4ka',
        color: '#010101',
    },
];

// Відео-картка: вантажиться й програється лише коли потрапляє у видиму область (економить трафік на телефоні)
function LazyVideo({ src, style }) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.muted = true;
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          const p = el.play();
          if (p && p.catch) p.catch(() => {});
        } else {
          el.pause();
        }
      });
    }, { threshold: 0.25 });
    io.observe(el);
    return () => io.disconnect();
  }, []);

  const openFullscreen = () => {
    const el = ref.current;
    if (!el) return;
    if (el.requestFullscreen) el.requestFullscreen();
    else if (el.webkitEnterFullscreen) el.webkitEnterFullscreen();
  };

  return (
    <video
      ref={ref}
      src={src}
      muted
      loop
      playsInline
      preload="none"
      onClick={openFullscreen}
      style={{ ...style, cursor: 'pointer' }}
    />
  );
}

// Фото та короткі відео залів. Усі ці файли треба покласти в папку public/
const GALLERY = [
  { type: 'image', src: '/zal-01.jpg' },
  { type: 'image', src: '/zal-02.jpg' },
  { type: 'image', src: '/zal-03.jpg' },
  { type: 'image', src: '/zal-04.jpg' },
  { type: 'image', src: '/zal-05.jpg' },
  { type: 'image', src: '/zal-06.jpg' },
  { type: 'image', src: '/zal-07.jpg' },
  { type: 'image', src: '/zal-08.jpg' },
  { type: 'image', src: '/zal-09.jpg' },
  { type: 'image', src: '/zal-10.jpg' },
  { type: 'video', src: '/zal-1.mp4' },
  { type: 'video', src: '/zal-2.mp4' },
  { type: 'video', src: '/zal-3.mp4' },
];
// Лише фото — для навігації в лайтбоксі
const PHOTOS = GALLERY.filter(g => g.type === 'image').map(g => g.src);

export default function HomePage({ onNavigate }) {
  const vw = useViewport();
  const isMobile = vw < 768;   // телефон — розкладка лишається як була
  const isWide = vw >= 1100;   // широкий екран — більше колонок, щоб заповнити простір

  // Лайтбокс галереї «Наші зали»: індекс фото або null
  const [lightbox, setLightbox] = useState(null);
  useEffect(() => {
    if (lightbox === null) return;
    const onKey = (e) => {
      if (e.key === 'Escape') setLightbox(null);
      else if (e.key === 'ArrowRight') setLightbox((i) => (i + 1) % PHOTOS.length);
      else if (e.key === 'ArrowLeft') setLightbox((i) => (i - 1 + PHOTOS.length) % PHOTOS.length);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [lightbox]);

  // Спільний вміст героя (бейдж, заголовок, опис, цифри) — однаковий на телефоні й десктопі
  const heroContent = (
    <>
      <div style={{
        background: '#e8c97e',
        color: '#0d0d0b',
        fontSize: 11,
        letterSpacing: '1.5px',
        textTransform: 'uppercase',
        fontWeight: 600,
        padding: '6px 16px',
        borderRadius: 20,
        display: 'inline-block',
        marginBottom: 16
      }}>
        Бар Lentochka · Ресторан Околиця
      </div>

      <div style={{
        fontFamily: "'Fraunces', serif", fontSize: 44, fontWeight: 300,
        lineHeight: 1.05, color: '#fff', letterSpacing: '-1px',
      }}>
        Ресторан<br />
        <span style={{
          fontFamily: "'Abril Fatface', serif",
          fontStyle: 'normal',
          fontWeight: 600,
          background: 'linear-gradient(90deg, #F9E79F 0%, #D4AF37 50%, #F9E79F 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          textShadow: '0 4px 20px rgba(212, 175, 55, 0.5)',
          display: 'inline-block',
          paddingRight: '5px'
        }}>
          Околиця
        </span>
      </div>

      <div style={{
        fontSize: 13, color: 'rgba(255,255,255,0.45)',
        marginTop: 12, fontWeight: 300, lineHeight: 1.7, maxWidth: 340,
      }}>
        БЕЗКОШТОВНА ДОСТАВКА 
        (м.Вінниця та прилеглі села) с.Якушинці, урочище Околиця І
      </div>

      {/* Stats */}
      <div style={{
        display: 'flex', gap: 28, marginTop: 24,
        paddingTop: 20, borderTop: '1px solid rgba(255,255,255,0.1)',
      }}>
        {[['5+', 'років досвіду'], ['120', 'посадкових місць'], ['80+', 'страв у меню']].map(([num, label]) => (
          <div key={label}>
            <div style={{ fontFamily: "'Fraunces', serif", fontSize: 26, fontWeight: 400, color: '#e8c97e' }}>{num}</div>
            <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.35)', fontWeight: 300, marginTop: 2 }}>{label}</div>
          </div>
        ))}
      </div>
    </>
  );

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', overflowY: 'auto' }}>

      {/* Hero */}
      {isMobile ? (
        // --- ТЕЛЕФОН: як було (текст + декоративні кола, без фото) ---
        <div style={{
          background: '#0d0d0b', padding: '36px 32px 32px',
          position: 'relative', overflow: 'hidden', flexShrink: 0,
        }}>
          <div style={{
            position: 'absolute', right: -30, top: -30,
            width: 180, height: 180, borderRadius: '50%',
            border: '1px solid rgba(255,255,255,0.06)', pointerEvents: 'none',
          }} />
          <div style={{
            position: 'absolute', right: 20, top: 20,
            width: 100, height: 100, borderRadius: '50%',
            border: '1px solid rgba(255,255,255,0.08)', pointerEvents: 'none',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 28, color: 'rgba(255,255,255,0.15)',
          }}>✦</div>

          {heroContent}
        </div>
      ) : (
        // --- ДЕСКТОП: текст ліворуч + фото залу і кнопка "Подзвонити" праворуч ---
        <div style={{
          background: '#0d0d0b', padding: '44px 40px 40px',
          position: 'relative', overflow: 'hidden', flexShrink: 0,
          display: 'flex', gap: 36, alignItems: 'center',
        }}>
          <div style={{ flex: '1 1 0', minWidth: 0 }}>
            {heroContent}
          </div>

          <div style={{ flex: '0 0 42%', maxWidth: 520, minWidth: 0 }}>
            <div style={{
              borderRadius: 16, overflow: 'hidden',
              border: '1px solid rgba(255,255,255,0.1)',
              height: 290, background: '#161512',
              boxShadow: '0 18px 40px rgba(0,0,0,0.35)',
            }}>
              <img
                src={process.env.PUBLIC_URL + '/hero-okolytsia.jpg'}
                alt="Зал ресторану Околиця"
                style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
              />
            </div>

            <a
              href="tel:+380967365196"
              style={{
                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
                marginTop: 12, padding: '13px 18px', borderRadius: 12,
                background: '#e8c97e', color: '#2c2208', textDecoration: 'none',
                fontSize: 14, fontWeight: 600, transition: 'background 0.18s',
              }}
              onMouseEnter={e => { e.currentTarget.style.background = '#f0d68f'; }}
              onMouseLeave={e => { e.currentTarget.style.background = '#e8c97e'; }}
            >
              📞 Подзвонити +38 (096) 736-51-96
            </a>
          </div>
        </div>
      )}

      {/* Прийом замовлень по кухні — до 21:00 */}
      <div style={{ padding: isMobile ? '18px 24px 0' : '22px 40px 0', flexShrink: 0 }}>
        <div style={{
          display: 'flex', alignItems: 'center', gap: isMobile ? 14 : 18,
          background: 'linear-gradient(105deg, #fffdf8 0%, #fbf3df 55%, #f7ecd0 100%)',
          border: '1px solid #ecdcb3',
          borderRadius: 16,
          padding: isMobile ? '15px 17px' : '18px 24px',
          boxShadow: '0 6px 22px rgba(176, 141, 60, 0.10)',
        }}>
          {/* Іконка-годинник у золотому крузі — у стилі карток "Про заклад" */}
          <div style={{
            width: isMobile ? 46 : 52, height: isMobile ? 46 : 52,
            flexShrink: 0, borderRadius: '50%',
            background: '#fff',
            border: '1px solid rgba(212, 175, 55, 0.35)',
            boxShadow: 'inset 0 0 0 4px rgba(212, 175, 55, 0.06)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: '#b0862c',
          }}>
            <svg width={isMobile ? 22 : 25} height={isMobile ? 22 : 25} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="9" />
              <path d="M12 7.5v4.7l3 1.8" />
            </svg>
          </div>

          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{
              fontSize: 10, letterSpacing: '2px', textTransform: 'uppercase',
              color: '#b08d3c', fontWeight: 600, marginBottom: 5,
            }}>Прийом замовлень по кухні</div>
            <div style={{
              fontFamily: "'Fraunces', serif",
              fontSize: isMobile ? 17 : 20, fontWeight: 400,
              color: '#2b2620', lineHeight: 1.2, letterSpacing: '-0.2px',
            }}>
              Щодня з{' '}
              <span style={{
                fontWeight: 600,
                background: 'linear-gradient(90deg, #C9962E 0%, #9A6E1B 100%)',
                WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}>10:30</span>{' '}до{' '}
              <span style={{
                fontWeight: 600,
                background: 'linear-gradient(90deg, #C9962E 0%, #9A6E1B 100%)',
                WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}>21:00</span>
            </div>
            {/* Невидимий балансир: зрівнює оптичний центр тексту з іконкою (= висота eyebrow) */}
            <div aria-hidden="true" style={{ height: 17 }} />
          </div>
        </div>
      </div>

      {/* Social links */}
      <div style={{ padding: isMobile ? '20px 24px 0' : '24px 40px 0', flexShrink: 0 }}>
        <div style={{
          fontSize: 10, letterSpacing: '2px', textTransform: 'uppercase',
          color: '#6b6560', marginBottom: 12, fontWeight: 500,
        }}>Ми в соцмережах</div>
        <div style={{ display: 'flex', gap: 10 }}>
          {SOCIALS.map(s => (
            <a
              key={s.name}
              href={s.url}
              target="_blank"
              rel="noreferrer"
              style={{
                display: 'flex', alignItems: 'center', gap: 8,
                padding: '10px 16px', borderRadius: 12,
                border: '1px solid #ddd5c8', background: '#fff',
                color: '#0d0d0b', textDecoration: 'none',
                fontSize: 13, fontWeight: 400,
                transition: 'all 0.18s',
              }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = s.color; e.currentTarget.style.color = s.color; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = '#ddd5c8'; e.currentTarget.style.color = '#0d0d0b'; }}
            >
              <span style={{ color: 'inherit' }}>{s.icon}</span>
              {s.name}
            </a>
          ))}
        </div>
      </div>

      {/* Features */}
      <div style={{ padding: isMobile ? '20px 24px 0' : '24px 40px 0', flexShrink: 0 }}>
        <div style={{
          fontSize: 10, letterSpacing: '2px', textTransform: 'uppercase',
          color: '#6b6560', marginBottom: 12, fontWeight: 500,
        }}>Про заклад</div>
        <div style={{ display: 'grid', gridTemplateColumns: isWide ? 'repeat(3, 1fr)' : '1fr 1fr', gap: 10 }}>
          {FEATURES.map(f => (
            <div 
              key={f.title} 
              onClick={() => {
                if (f.tab && onNavigate) {
                  onNavigate(f.tab, f.categoryId); 
                }
              }}
              style={{
                background: '#fff', borderRadius: 14, border: '1px solid #ddd5c8',
                padding: '14px', display: 'flex', alignItems: 'center', gap: 10,
                cursor: f.tab ? 'pointer' : 'default',
                transition: 'all 0.25s ease',
              }}
              onMouseEnter={e => {
                if (f.tab) {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow = '0 8px 20px rgba(212, 175, 55, 0.15)';
                  e.currentTarget.style.borderColor = '#d4af37';
                }
              }}
              onMouseLeave={e => {
                if (f.tab) {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                  e.currentTarget.style.borderColor = '#ddd5c8';
                }
              }}
            >
              <div style={{
                width: 38, height: 38, background: '#fdf9ee', borderRadius: 10,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                color: '#d4af37', flexShrink: 0, border: '1px solid rgba(212, 175, 55, 0.2)'
              }}>
                {f.icon}
              </div>
              
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 13, fontWeight: 600, color: '#0d0d0b' }}>{f.title}</div>
                <div style={{ fontSize: 11, color: '#6b6560', marginTop: 2, fontWeight: 400 }}>{f.desc}</div>
              </div>
              
              {f.tab && (
                <div style={{ color: '#d4af37', fontSize: 18, paddingRight: 4 }}>
                  →
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Gallery — наші зали */}
      <div style={{ padding: isMobile ? '22px 24px 0' : '30px 40px 0', flexShrink: 0 }}>
        <style>{`
          .zal-grid .zal-tile {
            transition: box-shadow .3s ease, border-color .3s ease;
            will-change: transform;
          }
          .zal-grid .zal-tile:hover {
            border-color: #d4af37;
            box-shadow: 0 16px 34px rgba(28, 22, 8, 0.20);
          }
          .zal-grid .zal-media { transition: transform .6s cubic-bezier(.2,.7,.2,1); }
          .zal-grid .zal-tile:hover .zal-media { transform: scale(1.07); }
          .zal-grid .zal-scrim { opacity: .5; transition: opacity .35s ease; }
          .zal-grid .zal-tile:hover .zal-scrim { opacity: .85; }
          .zal-grid .zal-expand {
            opacity: 0; transform: translateY(6px);
            transition: opacity .3s ease, transform .3s ease;
          }
          .zal-grid .zal-tile:hover .zal-expand { opacity: 1; transform: translateY(0); }
          .zal-grid .zal-play { transition: transform .3s ease, background .3s ease, border-color .3s ease; }
          .zal-grid .zal-tile:hover .zal-play {
            transform: translate(-50%, -50%) scale(1.08);
            background: rgba(13,13,11,0.5);
            border-color: #e8c97e;
          }
          @media (hover: none) { .zal-grid .zal-expand { display: none; } }
          @media (prefers-reduced-motion: reduce) {
            .zal-grid .zal-tile:hover .zal-media { transform: none; }
          }
        `}</style>

        {/* Заголовок секції */}
        <div style={{
          fontSize: 10, letterSpacing: '2px', textTransform: 'uppercase',
          color: '#b08d3c', marginBottom: 6, fontWeight: 600,
        }}>Галерея</div>
        <div style={{
          fontFamily: "'Fraunces', serif", fontWeight: 400,
          fontSize: isMobile ? 26 : 34, lineHeight: 1.1, color: '#0d0d0b',
          letterSpacing: '-0.5px',
        }}>Наші зали</div>
        <div style={{
          fontSize: isMobile ? 12.5 : 13.5, color: '#6b6560',
          marginTop: 8, marginBottom: 18, fontWeight: 300, maxWidth: 460, lineHeight: 1.6,
        }}>
          Торкніться будь-якого фото, щоб роздивитися зал у деталях.
        </div>

        <div
          className="zal-grid"
          style={
            isMobile
              ? { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }
              : {
                  display: 'grid',
                  gridTemplateColumns: `repeat(${isWide ? 4 : 3}, 1fr)`,
                  gridAutoRows: isWide ? '162px' : '150px',
                  gridAutoFlow: 'dense',
                  gap: 12,
                }
          }
        >
          {GALLERY.map((item, i) => {
            const isImg = item.type === 'image';
            const photoIdx = isImg ? PHOTOS.indexOf(item.src) : -1;

            // Мозаїка: на десктопі частина плиток більша — щоб галерея виглядала «зверстаною»,
            // а не сіткою однакових прев'ю. На телефоні — рівні пари + перше фото на всю ширину.
            let spanStyle;
            if (isMobile) {
              spanStyle = i === 0
                ? { gridColumn: '1 / -1', paddingTop: '56%' }
                : { paddingTop: '75%' };
            } else {
              spanStyle = { height: '100%', minHeight: 0 };
              if (i === 0) spanStyle = { ...spanStyle, gridColumn: 'span 2', gridRow: 'span 2' };
              else if (i === 3) spanStyle = { ...spanStyle, gridRow: 'span 2' };
              else if (i === 6) spanStyle = { ...spanStyle, gridColumn: 'span 2' };
              else if (i === 9) spanStyle = { ...spanStyle, gridRow: 'span 2' };
              else if (i === 10) spanStyle = { ...spanStyle, gridColumn: 'span 2' };
            }

            return (
              <div
                key={i}
                className="zal-tile"
                onClick={isImg ? () => setLightbox(photoIdx) : undefined}
                style={{
                  position: 'relative', width: '100%',
                  borderRadius: 16, overflow: 'hidden',
                  border: '1px solid #e4dcc9', background: '#0d0d0b',
                  cursor: isImg ? 'pointer' : 'default',
                  ...spanStyle,
                }}
              >
                {item.type === 'video' ? (
                  <LazyVideo
                    src={process.env.PUBLIC_URL + item.src}
                    style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                  />
                ) : (
                  <img
                    className="zal-media"
                    src={process.env.PUBLIC_URL + item.src}
                    alt="Зал ресторану Околиця"
                    loading="lazy"
                    style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                  />
                )}

                {/* Затемнення знизу — додає глибини */}
                <div className="zal-scrim" style={{
                  position: 'absolute', inset: 0, pointerEvents: 'none',
                  background: 'linear-gradient(to top, rgba(13,13,11,0.55) 0%, rgba(13,13,11,0) 42%)',
                }} />

                {item.type === 'video' ? (
                  // Кругла play-кнопка по центру — як у плеєрі
                  <div className="zal-play" style={{
                    position: 'absolute', top: '50%', left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 56, height: 56, borderRadius: '50%',
                    background: 'rgba(13,13,11,0.38)',
                    WebkitBackdropFilter: 'blur(3px)', backdropFilter: 'blur(3px)',
                    border: '1.5px solid rgba(255,255,255,0.8)',
                    boxShadow: '0 6px 20px rgba(0,0,0,0.35)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    pointerEvents: 'none',
                  }}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="#fff" style={{ marginLeft: 3 }}>
                      <path d="M8 5v14l11-7z" />
                    </svg>
                  </div>
                ) : (
                  // Іконка «збільшити» — з'являється на ховері
                  <div className="zal-expand" style={{
                    position: 'absolute', top: 10, right: 10,
                    width: 34, height: 34, borderRadius: '50%',
                    background: 'rgba(13,13,11,0.5)',
                    WebkitBackdropFilter: 'blur(4px)', backdropFilter: 'blur(4px)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    pointerEvents: 'none',
                  }}>
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M15 3h6v6" />
                      <path d="M9 21H3v-6" />
                      <path d="M21 3l-7 7" />
                      <path d="M3 21l7-7" />
                    </svg>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>

      {/* Лайтбокс — повне фото залу */}
      {lightbox !== null && (
        <div
          onClick={() => setLightbox(null)}
          style={{
            position: 'fixed', inset: 0, zIndex: 9999,
            background: 'rgba(0,0,0,0.92)',
            WebkitBackdropFilter: 'blur(6px)', backdropFilter: 'blur(6px)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20,
          }}
        >
          <img
            src={process.env.PUBLIC_URL + PHOTOS[lightbox]}
            alt="Зал ресторану Околиця"
            onClick={(e) => e.stopPropagation()}
            style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain', borderRadius: 10, boxShadow: '0 10px 50px rgba(0,0,0,0.6)' }}
          />
          <div onClick={() => setLightbox(null)} style={{ position: 'absolute', top: 14, right: 18, width: 44, height: 44, borderRadius: '50%', background: 'rgba(255,255,255,0.14)', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 26, cursor: 'pointer', userSelect: 'none' }}>×</div>
          <div onClick={(e) => { e.stopPropagation(); setLightbox((idx) => (idx - 1 + PHOTOS.length) % PHOTOS.length); }} style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', width: 46, height: 46, borderRadius: '50%', background: 'rgba(255,255,255,0.14)', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 30, cursor: 'pointer', userSelect: 'none' }}>‹</div>
          <div onClick={(e) => { e.stopPropagation(); setLightbox((idx) => (idx + 1) % PHOTOS.length); }} style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', width: 46, height: 46, borderRadius: '50%', background: 'rgba(255,255,255,0.14)', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 30, cursor: 'pointer', userSelect: 'none' }}>›</div>
          <div style={{ position: 'absolute', bottom: 16, left: '50%', transform: 'translateX(-50%)', color: 'rgba(255,255,255,0.85)', fontSize: 13, letterSpacing: 1 }}>{lightbox + 1} / {PHOTOS.length}</div>
        </div>
      )}

      {/* Info cards */}
      <div style={{ padding: isMobile ? '16px 24px 0' : '20px 40px 0', flexShrink: 0 }}>
        <div style={{
          fontSize: 10, letterSpacing: '2px', textTransform: 'uppercase',
          color: '#6b6560', marginBottom: 12, fontWeight: 500,
        }}>Контакти та інформація</div>
        <div style={{
          display: 'grid',
          gridTemplateColumns: isMobile ? '1fr' : (isWide ? 'repeat(4, 1fr)' : 'repeat(2, 1fr)'),
          gap: isMobile ? 8 : 12,
        }}>
          {INFO.map(item => {
            const isPhone = item.link;

            const card = (
              <div style={{
                background: '#fff',
                borderRadius: 14, 
                border: '1px solid #ddd5c8',
                padding: '14px 16px', display: 'flex', alignItems: 'center', gap: 14,
                cursor: isPhone ? 'pointer' : 'default',
                transition: 'all 0.2s',
                height: '100%',
              }}>
                <div style={{
                  width: 40, height: 40, 
                  background: '#f7f4ef', 
                  borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 20, flexShrink: 0,
                }}>{item.icon}</div>
                
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 10, color: '#6b6560', textTransform: 'uppercase', letterSpacing: '1px', fontWeight: 500 }}>
                    {item.label}
                  </div>
                  <div style={{ fontSize: 14, fontWeight: 500, color: '#0d0d0b', marginTop: 2 }}>
                    {item.value}
                  </div>
                  <div style={{ fontSize: 11, color: '#6b6560', fontWeight: 300, marginTop: 1 }}>
                    {item.sub}
                  </div>
                </div>
              </div>
            );

            if (isPhone) {
              return (
                <a key={item.label} href={item.link} style={{ textDecoration: 'none', display: 'block', WebkitTapHighlightColor: 'transparent' }}>
                  {card}
                </a>
              );
            }

            return (
              <div key={item.label} style={{ display: 'block' }}>
                {card}
              </div>
            );
          })}
        </div>
      </div>
          
      {/* Map */}
      <div style={{ padding: isMobile ? '16px 24px 24px' : '20px 40px 28px', flexShrink: 0 }}>
        <div style={{
          fontSize: 10, letterSpacing: '2px', textTransform: 'uppercase',
          color: '#6b6560', marginBottom: 12, fontWeight: 500,
        }}>Як нас знайти</div>
        <div style={{ background: '#fff', borderRadius: 16, border: '1px solid #ddd5c8', overflow: 'hidden', height: isMobile ? 200 : 360 }}>
          <iframe
            title="Карта"
            width="100%" height="100%" frameBorder="0"
            style={{ border: 0, display: 'block' }}
            src="https://maps.google.com/maps?q=Урочище+Околиця+1+Якушинці+Вінницька+область+23222&output=embed&z=16"
            allowFullScreen
          />
        </div>
        <button
          onClick={() => window.open('https://maps.google.com/?q=Урочище+Околиця+1+Якушинці+Вінницька+область+23222', '_blank')}
          style={{
            width: isMobile ? '100%' : 'fit-content', marginTop: 10, background: '#0d0d0b', color: '#fff',
            border: 'none', borderRadius: 12, padding: isMobile ? '13px' : '13px 36px',
            fontSize: 13, fontWeight: 500, cursor: 'pointer',
            fontFamily: "'Outfit', sans-serif", transition: 'background 0.15s',
          }}
          onMouseEnter={e => e.currentTarget.style.background = '#1a3a2a'}
          onMouseLeave={e => e.currentTarget.style.background = '#0d0d0b'}
        >
          Прокласти маршрут →
        </button>
      </div>
    </div>
  );
}
